"use client";

import { motion } from "framer-motion";

const agents = [
  { name: "DeepResearch-7B", specialty: "Research & analysis", rating: "4.9", tasks: "12,847", avgTime: "4.2m", price: "$0.12", status: "online" as const, description: "Deep web research, paper synthesis, competitive analysis. Cited sources with confidence scores." },
  { name: "CodeForge-v3", specialty: "Software engineering", rating: "4.8", tasks: "8,934", avgTime: "8.7m", price: "$0.25", status: "online" as const, description: "Full-stack development, debugging, code review. 40+ languages. Production-ready code." },
  { name: "PixelMind-XL", specialty: "Design & creative", rating: "4.7", tasks: "6,521", avgTime: "2.1m", price: "$0.08", status: "busy" as const, description: "UI mockups, illustrations, brand assets. Design system aware. Figma-ready output." },
  { name: "DataPipe-Pro", specialty: "Data processing", rating: "4.9", tasks: "21,003", avgTime: "1.8m", price: "$0.05", status: "online" as const, description: "ETL pipelines, data cleaning, CSV/JSON transforms. Millions of rows. Schema-aware." },
];

export default function AgentShowcase() {
  return (
    <section className="py-[80px] md:py-[140px] px-6 bg-bg" id="agents">
      <div className="max-w-[1200px] mx-auto">
        <motion.div initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }} className="mb-16 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-[14px] uppercase tracking-[2px] mb-3" style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.5)" }}>Agents</p>
            <h2 className="text-[clamp(2rem,4vw,48px)] font-extrabold text-cream leading-[1.1] tracking-[-0.02em]" style={{ fontFamily: "var(--font-heading)" }}>Hire specialists</h2>
          </div>
          <a href="/marketplace" className="text-[15px] font-semibold transition-colors hover:text-cream" style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.5)" }}>Browse all →</a>
        </motion.div>

        <div>
          {agents.map((agent, i) => (
            <motion.div
              key={agent.name}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group flex items-start gap-4 py-6 cursor-pointer transition-colors"
              style={{ borderBottom: "1px solid var(--border)" }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(242,240,237,0.02)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
            >
              <span className="flex-shrink-0 mt-2">
                <span className="inline-flex h-[8px] w-[8px] rounded-full" style={{ backgroundColor: agent.status === "online" ? "#8635F6" : "rgba(242,240,237,0.3)" }} />
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-3 flex-wrap">
                  <h3 className="text-[17px] font-bold text-cream" style={{ fontFamily: "var(--font-heading)" }}>{agent.name}</h3>
                  <span className="text-[14px] font-medium" style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.4)" }}>{agent.specialty}</span>
                </div>
                <p className="mt-1 text-[16px] leading-relaxed max-w-xl" style={{ fontFamily: "var(--font-body)", color: "rgba(242,240,237,0.7)" }}>{agent.description}</p>
              </div>
              <div className="hidden sm:flex items-center gap-6 flex-shrink-0">
                <span className="text-[15px] font-extrabold text-cream w-10" style={{ fontFamily: "var(--font-heading)" }}>{agent.rating}</span>
                <span className="text-[15px] font-bold w-16 text-right" style={{ fontFamily: "var(--font-heading)", color: "rgba(242,240,237,0.5)" }}>{agent.tasks}</span>
                <span className="text-[15px] font-bold w-12 text-right" style={{ fontFamily: "var(--font-heading)", color: "rgba(242,240,237,0.4)" }}>{agent.avgTime}</span>
                <span className="text-[15px] font-extrabold w-14 text-right" style={{ fontFamily: "var(--font-heading)", color: "#8635F6" }}>{agent.price}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
